import List from '@mui/material/List';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FileList from './FileList';
import Text from '../../elements/text/Text';

const FileSection = (props) => {
  const { t } = useTranslation('instance');

  return (
    <div>
      <Text bodyBold color="textSecondary">
        {t('selectedFile')}
      </Text>
      <List dense={true} aria-label="file list" disablePadding>
        <FileList {...props} />
      </List>
    </div>
  );
};

export default FileSection;

FileSection.propTypes = {
  files: PropTypes.array.isRequired,
  removeFile: PropTypes.func.isRequired,
};
